import React, { FC } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import SelectVesselPage from './SelectVesselFeature';

const VesselsFeature: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const handleSelectVessel = () => {
    // TODO: Add event capture

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (location?.state?.returnUrl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      history.push(location.state.returnUrl);
      return;
    }

    history.goBack();
  };

  return (
    <Switch>
      <Route path="/maps/vessels/select-vessel" exact>
        <SelectVesselPage
          onBack={history.goBack}
          onSelectVessel={handleSelectVessel}
        />
      </Route>
    </Switch>
  );
};

export default VesselsFeature;
